import React, { useContext, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RHFLegacyField from '#component/form/rhf/rhf-legacy-field';
import { ErrorsContext } from '#component/project/form/error-context';
import {
  PanelDetails,
  PanelSummary,
  StyledAccordion,
  StyledAvatar,
  StyledField,
  StyledTitle,
  TitleContainer
} from './styles';
import PackageItemActions from './package-item-actions';
import propTypes from './prop-types';
import DimensionsWeightFields from './dimensions-weight-fields';

/**
 * Renders MUI expansion panel with package item fields.
 * Contains button to remove package-item.
 * @returns {React.FC}
 */

const PackageItem = props => {
  const {
    index,
    member,
    remove,
    expanded,
    handleSetExpanded,
    item,
    forceError
  } = props;
  const { errors, setErrors } = useContext(ErrorsContext);

  const [tareWeight, setTareWeight] = useState(null);

  const handlePanelClick = () => {
    if (errors.packages?.[index]) {
      const untouchedErrors = [...errors.packages];
      untouchedErrors[index] = false;
      setErrors(s => ({ ...s, packages: untouchedErrors }));
    }
  };

  const deletePackageItem = event => {
    event.stopPropagation();
    remove(index);
  };

  return (
    <StyledAccordion
      hasError={!!errors.packages?.[index]}
      expanded={expanded}
      onChange={handleSetExpanded(member)}
      onClick={handlePanelClick}
    >
      <PanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index + 1}a-content`}
        id={`panel${index + 1}a-header`}
      >
        <TitleContainer>
          <StyledAvatar>{index + 1}</StyledAvatar>
          <StyledTitle>{item.label}</StyledTitle>
        </TitleContainer>
        <PackageItemActions deletePackageItem={deletePackageItem} />
      </PanelSummary>
      <PanelDetails>
        <RHFLegacyField
          name={`${member}.label`}
          component={StyledField}
          placeholder="Package type"
          variant="outlined"
          forceError={forceError}
        />
        <DimensionsWeightFields
          member={member}
          tareWeight={tareWeight}
          setTareWeight={setTareWeight}
          disabled={false}
          forceError={forceError}
        />
      </PanelDetails>
    </StyledAccordion>
  );
};

PackageItem.propTypes = propTypes;

export default PackageItem;
